import type { ChatFolder } from '@andresot/protocol';
import type { FolderCreate, FolderUpdate } from '@andresot/protocol/folders';
import { request } from './client.js';

export async function fetchFolders(): Promise<ChatFolder[]> {
	const response = await request<{ folders: ChatFolder[] }>('/api/folders');
	return response.folders;
}

export async function createFolder(input: FolderCreate): Promise<ChatFolder> {
	const response = await request<{ folder: ChatFolder }>('/api/folders', { body: input });
	return response.folder;
}

export async function updateFolder(folderId: string, input: FolderUpdate): Promise<ChatFolder> {
	const response = await request<{ folder: ChatFolder }>(
		`/api/folders/${encodeURIComponent(folderId)}`,
		{ method: 'PATCH', body: input }
	);
	return response.folder;
}

export async function deleteFolder(folderId: string): Promise<void> {
	await request(`/api/folders/${encodeURIComponent(folderId)}`, { method: 'DELETE' });
}

export async function reorderFolders(folderIds: string[]): Promise<ChatFolder[]> {
	const response = await request<{ folders: ChatFolder[] }>('/api/folders/reorder', {
		method: 'PATCH',
		body: { folderIds }
	});
	return response.folders;
}
